<script setup lang="ts">
definePageMeta({
  layout: 'fund',
})

useSetSEO()
useScrollRestoration()

const { locale } = useI18n()
const etcStore = useEtcStore()
const isLoading = ref(false)
const isError = ref(false)

watch(
  () => locale.value,
  (cur) => {
    if (cur) {
      setTimeout(() => {
        fetchNotices(true)
      })
    }
  }
)

onMounted(() => {
  if (etcStore.fundNoticeList.items.length) return
  fetchNotices(true)
})

// 공지사항 목록 페이징 조회
const fetchNotices = async (refresh = false) => {
  try {
    isLoading.value = true
    isError.value = false
    await etcStore.fetchBoardList(
      { ...etcStore.fundNoticeList.payload },
      refresh
    )
  } catch {
    isError.value = true
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <div class="board-wrapper">
    <div class="list-area">
      <div class="list-box">
        <NovaBoxEmptyMessage
          v-if="
            etcStore.fundNoticeList.refresh &&
            !etcStore.fundNoticeList.items.length &&
            !isError
          "
          :message="$t('statusMessages.boardList.empty')"
          :fill="true"
        />

        <NovaBoxEmptyMessage
          v-if="!etcStore.fundNoticeList.items.length && isError"
          :message="$t('statusMessages.boardList.error')"
          :fill="true"
        />

        <NovaLoadingIndicator
          v-if="etcStore.fundNoticeList.refresh && isLoading"
          :size="80"
          :fill="true"
          :bg-bright="'light'"
        />

        <NovaRecyclerGrid
          v-if="etcStore.fundNoticeList.items.length"
          :items="etcStore.fundNoticeList.items"
          :is-last="etcStore.fundNoticeList.last"
          :is-loading="isLoading"
          :is-error="isError"
          :is-refresh="etcStore.fundNoticeList.refresh"
          :key-name="'nttGroupId'"
          :page-mode="true"
          :responsive="{
            mobile: { columns: 1, rowGap: 20, columnGap: 0 },
            tablet: { columns: 1, rowGap: 20, columnGap: 0 },
            desktop: { columns: 1, rowGap: 20, columnGap: 0 },
          }"
          @load-more="fetchNotices"
        >
          <template #item="{ item }">
            <NovaBoxBoardListNoticeItem
              :source="item"
              :notice-type="'funding'"
            />
          </template>
        </NovaRecyclerGrid>
      </div>
    </div>
    <NuxtPage />
  </div>
</template>

<style lang="scss" scoped>
.board-wrapper,
.list-area,
.list-box,
.list {
  height: 100%;
  overflow: hidden;
}

.board-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 40px;
  color: $color-text-2;

  .list-area {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    > .title {
      @include text-style($text-heading2-bold);
      line-height: 40px;
    }
  }
}

@include mobile {
  .board-wrapper {
    padding: 15px 20px;
    flex-direction: column;
    gap: 20px;

    .list-area {
      width: 100%;

      .list-box {
        padding-top: 15px;
      }
    }
  }
}
</style>
